import { doc, getDoc } from "firebase/firestore";

import { FIRESTORE_COLLECTIONS } from "@/lib/firebase/collections";
import { getFirestoreDb } from "@/lib/firebase/firestore-instance";
import type { FirestoreUserDoc } from "@/lib/firebase/types";

export {
  getFeaturedPublicRepertoires,
  getLatestPublicRepertoires,
  getRepertoireById,
  getUserRepertoires,
} from "@/lib/firebase/repertoires";

export { subscribeActiveSponsors } from "@/lib/firebase/sponsors";

export async function getUserDocument(
  uid: string,
): Promise<FirestoreUserDoc | null> {
  const snap = await getDoc(
    doc(getFirestoreDb(), FIRESTORE_COLLECTIONS.users, uid),
  );
  if (!snap.exists()) {
    return null;
  }
  return snap.data() as FirestoreUserDoc;
}

/** Favorites live on `users/{uid}.favoriteSongIds` (mobile primary store). */
function normalizeFavoriteSongId(value: unknown): string | null {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  if (typeof value === "number" && Number.isFinite(value) && value > 0) {
    return String(Math.floor(value));
  }
  return null;
}

export async function getFavoriteSongIds(uid: string): Promise<string[]> {
  const userDoc = await getUserDocument(uid);
  const ids = userDoc?.favoriteSongIds;
  if (!Array.isArray(ids)) {
    return [];
  }
  const out: string[] = [];
  const seen = new Set<string>();
  for (const raw of ids) {
    const id = normalizeFavoriteSongId(raw);
    if (!id || seen.has(id)) {
      continue;
    }
    seen.add(id);
    out.push(id);
  }
  return out;
}

